import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { acConSizeChange } from '../actions/acConSizeChange';
// import _ from "underscore";
// import moment from "moment";

// import ScrollY from "../containers/ScrollY";
import { acPopVizibil } from "../actions/acPopVizibil";

class PopOficialLinks extends React.Component {
  constructor() {
    super();
    this.state = { height: null };
  }
  componentDidUpdate() {
    if (this.refPop && this.state.height === null) {
      if (this.props.conSizeChange && this.props.conSizeChange.colMid < this.refPop.offsetHeight) {
        this.setState({ height: this.refPop.offsetHeight + 120 })
        this.props.acConSizeChange({ colMid: this.refPop.offsetHeight + 120 })
      }
    }
  }
  popHead() {
    return (
      <div className="con-title module-header1">
        <div className="popup-title">
          <span>{this.props.multiLang.oficialLinks.txt}</span>
          <span onClick={this.closePop.bind(this)}>x</span>
        </div>
      </div>
    );
  }
  popBody() {
    var tr = [], columns1 = [], columns2 = [], columns3 = []
    if (this.props.loterii) {
      this.props.loterii.map((val, i) => {
        if (i % 3 === 0) {
          columns1.push(
            <tr key={i} >
              <td>
                <a className="img-con" target="_blank" rel="noopener noreferrer" href={val.official_link}>
                  <img
                    src={
                      "img/steaguri/" +
                      this.props.appProps.steaguri +
                      "/" +
                      val.country_flags.toLowerCase().replace(/ /g, "_") +
                      ".png"
                    }
                    alt=""
                  />
                </a>
                <a target="_blank" rel="noopener noreferrer" href={val.official_link}>
                  <div className="lottery_name">{val.name_lot + " " + val.game_type}</div>
                </a>
              </td>
            </tr>
          )
        } else if (i % 3 === 1) {
          columns2.push(
            <tr key={i} >
              <td>
                <a className="img-con" target="_blank" rel="noopener noreferrer" href={val.official_link}>
                  <img
                    src={
                      "img/steaguri/" +
                      this.props.appProps.steaguri +
                      "/" +
                      val.country_flags.toLowerCase().replace(/ /g, "_") +
                      ".png"
                    }
                    alt=""
                  />
                </a>
                <a target="_blank" rel="noopener noreferrer" href={val.official_link}>
                  <div className="lottery_name">{val.name_lot + " " + val.game_type}</div>
                </a>
              </td>
            </tr>
          )
        } else if (i % 3 === 2) {
          columns3.push(
            <tr key={i} >
              <td>
                <a className="img-con" rel="noopener noreferrer" target="_blank" href={val.official_link}>
                  <img
                    src={
                      "img/steaguri/" +
                      this.props.appProps.steaguri +
                      "/" +
                      val.country_flags.toLowerCase().replace(/ /g, "_") +
                      ".png"
                    }
                    alt=""
                  />
                </a>
                <a target="_blank" rel="noopener noreferrer" href={val.official_link}>
                  <div className="lottery_name">{val.name_lot + " " + val.game_type}</div>
                </a>
              </td>
            </tr>
          )
        }
        return (columns1, columns2, columns3)
      });
      var maxPerColumn = (Math.round(this.props.loterii.length / 4))

      if (columns1.length < maxPerColumn) {
        let dif1 = maxPerColumn - columns1.length
        for (let e = 0; e < dif1; e++) {
          columns1.push(
            <tr className="__empty" key={maxPerColumn + e} >
              <td className="__empty"></td>
            </tr>
          )
        }
      }
      if (columns2.length < maxPerColumn) {
        let dif2 = maxPerColumn - columns2.length
        for (let f = 0; f < dif2; f++) {
          columns2.push(
            <tr className="__empty" key={maxPerColumn + f} >
              <td className="__empty"></td>
            </tr>
          )
        }
      }
      if (columns3.length < maxPerColumn) {
        let dif3 = maxPerColumn - columns3.length
        for (let g = 0; g < dif3; g++) {
          columns3.push(
            <tr className="__empty" key={maxPerColumn + g} >
              <td className="__empty"></td>
            </tr>
          )
        }
      }
      tr =
        <tr>
          <td className="outsider-column" key={1}><table className="insider-table"><tbody>{columns1}</tbody></table></td>
          <td className="outsider-column" key={2}><table className="insider-table"><tbody>{columns2}</tbody></table></td>
          <td className="outsider-column" key={3}><table className="insider-table"><tbody>{columns3}</tbody></table></td>
        </tr>
    }
    var tabel = (
      <table className="oficialLinksTable">
        <tbody>{tr}</tbody>
      </table>
    );
    return (
      <div className="bodyContainer">
        {tabel}
        {/* <ScrollY
          scrollData={tabel}
          width="inherit"
          height={683}
          amount={100}
          speed={10}
          scrollBar={true}
          scrollBut={false}
        /> */}
      </div>
    );
  }
  closePop() {
    this.props.acPopVizibil({ popVizibil: false });
  }
  render() {
    return (
      <div ref={(f) => this.refPop = f} className="popUp-Content oficial_links_container">
        <div className="runde-child">
          {this.popHead()}
          {this.popBody()}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    popVizibil: state.popVizibil,
    multiLang: state.multiLang,
    appProps: state.appProps,
    loterii: state.loterii,
    activeLot: state.activeLot,
    conSizeChange: state.conSizeChange,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      acPopVizibil: acPopVizibil,
      acConSizeChange: acConSizeChange
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(PopOficialLinks);
